<template>
  <div class="text-center">
    <h2 id="iphone" class="mb-3">スマホのホーム画面に<br>MSC会員サイトのアイコンを追加<br>（iPhone用）</h2>
    <iframe width="342" height="607" src="https://www.youtube.com/embed/k3YIwv_6HVg" title="ホーム画面にアイコン追加＜iPhone版＞" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
  </div>
  <div class="text-center mt-5 pt-5">
    <router-link class="btn" to="/">会員サイトトップへ</router-link>
  </div>
</template>


<style scoped>
</style>

<script>
</script>